'use client';

import Cookies from 'js-cookie';
import getSsoBaseUrl from './getSsoBaseUrl';

const accessTokenProperty = 'access_token';
export default function redirectSignin() {
  // fix old version cookie bug
  Cookies.remove(accessTokenProperty);
  Cookies.remove(accessTokenProperty, {
    domain: 'rockx.com',
  });

  const redirectUri = encodeURIComponent(
    `${location.origin}/oauth/callback?redirect_uri=${location.pathname}`
  );
  const ssoBaseUrl = getSsoBaseUrl();
  const href = `${ssoBaseUrl}/signin?redirect_uri=${redirectUri}`;

  console.log('====================================');
  console.log('redirect', href);
  console.log('====================================');

  location.href = href;
}
